"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function mapToObj(strMap) {
  var obj = {};

  var _iterator = _createForOfIteratorHelper(strMap),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
          k = _step$value[0],
          v = _step$value[1];

      obj[k] = v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return obj;
}

var _default = mapToObj;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wdXJlLWZ1bmN0aW9ucy9tYXAtdG8tb2JqLnRzIl0sIm5hbWVzIjpbIm1hcFRvT2JqIiwic3RyTWFwIiwib2JqIiwiayIsInYiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsU0FBU0EsUUFBVCxDQUFrQkMsTUFBbEIsRUFBb0Q7QUFDbEQsTUFBTUMsR0FBRyxHQUFHLEVBQVo7O0FBRGtELDZDQUU5QkQsTUFGOEI7QUFBQTs7QUFBQTtBQUVsRCx3REFBNEI7QUFBQTtBQUFBLFVBQWhCRSxDQUFnQjtBQUFBLFVBQWRDLENBQWM7O0FBQzFCRixNQUFBQSxHQUFHLENBQUNDLENBQUQsQ0FBSCxHQUFTQyxDQUFUO0FBQ0Q7QUFKaUQ7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFLbEQsU0FBT0YsR0FBUDtBQUNEOztlQUVjRixRIiwic291cmNlc0NvbnRlbnQiOlsiZnVuY3Rpb24gbWFwVG9PYmooc3RyTWFwOiBNYXA8c3RyaW5nLCBhbnk+KTogb2JqZWN0IHtcbiAgY29uc3Qgb2JqID0ge307XG4gIGZvciAoY29uc3QgW2ssdl0gb2Ygc3RyTWFwKSB7XG4gICAgb2JqW2tdID0gdjtcbiAgfVxuICByZXR1cm4gb2JqO1xufVxuXG5leHBvcnQgZGVmYXVsdCBtYXBUb09iajtcbiJdfQ==